/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { PracticeReopen } from '../models';
/**
 * PracticeApi - axios parameter creator
 * @export
 */
export const PracticeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Assign practice to operator
         * @param {PracticeReopen} [practiceReopen] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        practiceReopen: async (practiceReopen?: PracticeReopen, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/practice/reopen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(practiceReopen, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PracticeApi - functional programming interface
 * @export
 */
export const PracticeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PracticeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Assign practice to operator
         * @param {PracticeReopen} [practiceReopen] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async practiceReopen(practiceReopen?: PracticeReopen, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.practiceReopen(practiceReopen, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticeApi.practiceReopen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PracticeApi - factory interface
 * @export
 */
export const PracticeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PracticeApiFp(configuration)
    return {
        /**
         * 
         * @summary Assign practice to operator
         * @param {PracticeReopen} [practiceReopen] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        practiceReopen(practiceReopen?: PracticeReopen, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.practiceReopen(practiceReopen, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PracticeApi - interface
 * @export
 * @interface PracticeApi
 */
export interface PracticeApiInterface {
    /**
     * 
     * @summary Assign practice to operator
     * @param {PracticeReopen} [practiceReopen] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeApiInterface
     */
    practiceReopen(practiceReopen?: PracticeReopen, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * PracticeApi - object-oriented interface
 * @export
 * @class PracticeApi
 * @extends {BaseAPI}
 */
export class PracticeApi extends BaseAPI implements PracticeApiInterface {
    /**
     * 
     * @summary Assign practice to operator
     * @param {PracticeReopen} [practiceReopen] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticeApi
     */
    public practiceReopen(practiceReopen?: PracticeReopen, options?: RawAxiosRequestConfig) {
        return PracticeApiFp(this.configuration).practiceReopen(practiceReopen, options).then((request) => request(this.axios, this.basePath));
    }
}

